<template>
  <div class="ChatExpertListPage">
    <MobileNav :page_title="nav_title" :filter_count="selectedFilterCount" />

    <!-- Left Section: Filters -->
    <div class="filters-section" v-if="isDesktop">
      <Filters @update-filter-count="updateFilterCount" />
    </div>

    <!-- Right Section: Expert List with Search Input -->
    <div  style="width: 100%;" class="expert-list-section" v-if="!isExpertListLoading && !filteredExperts.length" >
      <NoDataFound ></NoDataFound>
    </div>
    <div class="expert-list-section" v-loading="isExpertListLoading">

      <ExpertList :experts="filteredExperts" />
    </div>

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import MobileNav from "@/components/MobileNav.vue";
import Filters from "@/components/ChatFilters.vue";
import ExpertList from "@/components/ChatExpertCard.vue";
import ProcessKycComponent from "@/components/NewKycFlow.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import NoDataFound from "@/components/NoDataFound.vue";

export default {
  components: {
    Filters,
    ExpertList,
    MobileNav,
    ProcessKycComponent,
    NoDataFound
  },
  mixins: [screenSize],

  data() {
    return {
      nav_title: "Experts",
      searchTerm: "",
      experts: [],
      selectedFilterCount: 0,
      userProfile: {},
      planSubscriptionStatusDetails: null,
      isExpertListLoading: false,
    };
  },

  watch: {
    getPlanSubscriptionStatus(newValue, oldValue) {
      this.planSubscriptionStatusDetails = newValue.message;

      if (
        this.planSubscriptionStatusDetails &&
        this.planSubscriptionStatusDetails.extra_info.transaction_status ==
        "SUCCESS"
      ) {
        if (this.planSubscriptionStatusDetails.data.plan == "Publisher") {
          localStorage.setItem(
            "publisher_plan_details",
            JSON.stringify(this.planSubscriptionStatusDetails.data)
          );
        } else {
          localStorage.setItem(
            "plan_details",
            JSON.stringify(this.planSubscriptionStatusDetails.data)
          );
        }
        this.$store.commit("commitKycDialog", true);
      }
    },
  },

  created() {
    this.userProfile = JSON.parse(localStorage.getItem("profile"));

    this.getExpertList();
  },

  mounted() {
    // socket.on('connect', () => {
    //   console.log('Connected to server');
    // });

    // // Handle disconnection
    // socket.on('disconnect', () => {
    //   console.log('Disconnected from server');
    // });

    // await socket.on('chat-message', (data) => {
    //   console.log("chat-message", data);
    // });
  },

  methods: {
    updateFilterCount(newCount) {
      this.selectedFilterCount = newCount;
    },

    async selectedUser(user) {
      console.log("selected expert from expert card", user);

      // await socket.emit('join_room', { room: 124 });


      await this.joinRoom(user.roomId);
    },

    joinRoom(room) {
      return new Promise((resolve, reject) => {
        socket.emit('join_room', { room: room }, (response) => {
          if (response && response.status === 'joined') {
            console.log(`Successfully joined room: ${response.room}`);

            if (response.room) {
              this.$store.commit("commitRoomId", response.room);
            }

            this.$router.push({ path: "/chat_window" });
            resolve(response);
          } else {
            reject(new Error('Failed to join room'));
          }
        });
      });
    },

    getExpertList() {
      this.isExpertListLoading = true;
      serverAddr
        .get("/user/admin/chat_expert_list")
        .then((response) => {
          if (response.data.status && response.data.data.length) {

            response.data.data.forEach((e, index) => {
              e.roomId = `room_${index + 1}`
            })

            this.experts = response.data.data;
          } else {
            this.experts = [];
          }
          this.isExpertListLoading = false;
        })
        .catch(
          function (error) {
            this.isExpertListLoading = false;
            console.log(error);
          }.bind(this)
        );
    },
  },

  // beforeDestroy(){
  //   console.log("destroying socket from expert list page");
  //   socket.disconnect();
  // },

  computed: {
    filteredExperts() {
      let experts = [];

      if (this.searchTerm.trim()) {
        experts = this.experts.filter((expert) =>
          expert.full_name.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      } else {
        experts = this.experts;
      }

      return experts;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ChatExpertListPage {
  margin-top: 60px;
  display: flex;
  height: calc(100vh - 70px);
  border-top: 1px solid #ececec;
  overflow-y: hidden;

  .expert-list-section {
    flex-grow: 1;
    padding: 20px;
    overflow-y: auto;
    background-color: #f8f8f8;

    .search-input {
      margin-bottom: 20px;
      max-width: 270px;
      border-radius: 10px;

      .el-input__inner {
        border-radius: 10px;
      }
    }

    .search-icon {
      font-size: 16px;
      vertical-align: middle;
      position: absolute;
      right: 15px;
      color: #797979;
      top: 8px;
    }
  }
}

@media screen and (max-width: 1284px) {
  .ChatExpertListPage {
    height: calc(100vh - 128px);
  }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ChatExpertListPage {
  .expert-list-section {
    .search-input {
      .el-input__inner {
        border-radius: 20px;
      }
    }
  }
}
</style>
